<button class="btn btn-lg btn-primary text-white mb-5" (click)="back()"><i class="fa fa-chevron-left" aria-hidden="true"></i> Zpět</button>

<div class="card my-4">
  <div class="card-body">
    <p>Dotazník pro dárce krve</p>
    <a href="/files/DOTAZNÍK%20PRO%20DÁRCE%20KRVE_rev_1_2021.pdf" download="DOTAZNÍK PRO DÁRCE KRVE_rev_1_2021.pdf"><button class="btn btn-primary text-white"><i class="fa fa-cloud-download" aria-hidden="true"></i> Stáhnout soubor</button></a>
  </div>
</div>

<div class="card my-4">
  <div class="card-body">
    <p>Sebevyloučení</p>
    <a href="/files/Formulář_samovyloučen%C3%AD.pdf" download="Formulář_samovyloučení.pdf"><button class="btn btn-primary text-white"><i class="fa fa-cloud-download" aria-hidden="true"></i> Stáhnout soubor</button></a>
  </div>
</div>

<div class="card my-4">
  <div class="card-body">
    <p>Zdravotní překážky darování krve</p>
    <a href="/files/Zdravotn%C3%AD%20překážky%20darován%C3%AD%20krve.pdf" download="Zdravotní překážky darování krve.pdf"><button class="btn btn-primary text-white"><i class="fa fa-cloud-download" aria-hidden="true"></i> Stáhnout soubor</button></a>
  </div>
</div>
